import { render, staticRenderFns } from "./addSubject.vue?vue&type=template&id=a013b760&scoped=true&"
import script from "./addSubject.vue?vue&type=script&lang=js&"
export * from "./addSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a013b760",
  null
  
)

export default component.exports